<template>
  <b-row>
    <StepperCol :step="12" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        室外機の設置場所は？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{ selectedTitle }}</span>
          <div class="d-block text-muted">
            ¥{{ selectedPrice.toLocaleString() }}
            {{ selectedPrice === 0 ? "-" : "~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-row>
          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 0 ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="5"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">通常設置</h6>
                  <p class="mb-0 text-danger h5 font-weight-normal">
                    地面や<br />ベランダ
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="7" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-1@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 1 ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">その他 / 不明</h6>
                  <p class="mb-0 text-danger h5 font-weight-normal"></p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      <span class="h3 ml-1">現地で見積り</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-6@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 2 ? 'selected' : ''"
              @click="buttonClicked(2)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="5"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">壁面置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;既設架台再利用&#41;
                  </p>

                  <p class="mb-0 text-danger h6 md-h5 font-weight-normal">
                    建物の壁面<br />に直接配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">7,700~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="7" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-2@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 3 ? 'selected' : ''"
              @click="buttonClicked(3)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="5"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">壁面置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;架台新設交換&#41;
                  </p>
                  <p class="mb-0 text-danger h6 md-h5 font-weight-normal">
                    建物の壁面<br />に直接配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">16,500~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="7" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-2@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 4 ? 'selected' : ''"
              @click="buttonClicked(4)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="5"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">天つり置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;既設架台再利用&#41;
                  </p>

                  <p class="mb-0 text-danger h6 md-h5 font-weight-normal">
                    ベランダなどの<br class="d-none d-md-block" />天井から吊るす
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">7,700~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="7" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-3@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          
          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 5 ? 'selected' : ''"
              @click="buttonClicked(5)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="5"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">天つり置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;架台新設交換&#41;
                  </p>

                  <p class="mb-0 text-danger h6 md-h5 font-weight-normal">
                    ベランダなどの<br class="d-none d-md-block" />天井から吊るす
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">16,500~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="7" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-3@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 6 ? 'selected' : ''"
              @click="buttonClicked(6)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">屋根置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;既設架台再利用&#41;
                  </p>

                  <p class="mb-0 text-danger h5 font-weight-normal">
                    屋根に配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">7,700~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-4@2x.png')"
                    style="width: auto; height: 138px"
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 7 ? 'selected' : ''"
              @click="buttonClicked(7)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">屋根置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;架台新設交換&#41;
                  </p>

                  <p class="mb-0 text-danger h5 font-weight-normal">
                    屋根に配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">16,500~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-4@2x.png')"
                    style="width: auto; height: 138px"
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 8 ? 'selected' : ''"
              @click="buttonClicked(8)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">二段置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;既設架台再利用&#41;
                  </p>

                  <p class="mb-0 text-danger h5 font-weight-normal">
                    重ねて配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-5@2x.png')"
                    style="width: auto; height: 138px"
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="selectedAnswer == 9 ? 'selected' : ''"
              @click="buttonClicked(9)"
            >
              <b-row no-gutters class="h-100">
                <b-col
                  cols="6"
                  class="py-2 pl-3 d-flex flex-column justify-content-between"
                >
                  <h6 class="h4 mb-0">二段置き</h6>
                  <p class="mb-0 h6 md-h5 font-weight-normal" style="white-space: nowrap;">
                    &#40;架台新設交換&#41;
                  </p>

                  <p class="mb-0 text-danger h5 font-weight-normal">
                    重ねて配置
                  </p>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">22,000~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="6" class="d-flex align-items-end pr-2">
                  <b-img
                    :src="require('@/assets/images/q-10-5@2x.png')"
                    style="width: auto; height: 138px"
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>

        </b-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";
import config from "../../const";

const titles = [
  "地面やベランダ",
  "その他 / 不明",
  "壁面置き(既設架台再利用)",
  "壁面置き(架台新設交換)",
  "天つり置き(既設架台再利用)",
  "天つり置き(架台新設交換)",
  "屋根置き(既設架台再利用)",
  "屋根置き(架台新設交換)",
  "二段置き(既設架台再利用)",
  "二段置き(架台新設交換)",
];

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      selectedAnswer: null,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 12) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
    selectedTitle() {
      if (this.selectedAnswer == null) {
        return "";
      }
      return titles[this.selectedAnswer];
    },
    selectedPrice() {
      if (this.selectedAnswer == null) {
        return "";
      }
      return config.PRICES['unitType'][this.selectedAnswer];
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.selectedAnswer = null;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doUpdateMaxStep: "doUpdateMaxStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      this.selectedAnswer = value;
      this.doSaveAnswer({ keyword: 'unit_type', answer: value });
      if (value == 2 || value == 3 || value == 6 || value == 7) {
        this.doSaveAnswer({ keyword: 'unit_floor', answer: null });
        this.doUpdateStep(13);
        this.doUpdateMaxStep(13);
      } else {
        this.doSaveAnswer({ keyword: 'unit_floor', answer: 0 });
        this.doUpdateStep(14);
      }
      this.shrinking = true;
    },
  },
};
</script>